export default __webpack_public_path__ + "static/media/icon-care.b6c2b206.svg";